var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcClock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 31 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.5 7.5c.69 0 1.25.56 1.25 1.25v6.727l4.309 2.155a1.25 1.25 0 1 1-1.118 2.236l-5-2.5a1.25 1.25 0 0 1-.691-1.118v-7.5c0-.69.56-1.25 1.25-1.25",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.5 25c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10m0 2.5C22.404 27.5 28 21.904 28 15S22.404 2.5 15.5 2.5 3 8.096 3 15s5.596 12.5 12.5 12.5",
  clipRule: "evenodd"
})));
export default SvgIcClock;